export const PUBLICATION_MENU_SEARCH = 'publication.page.menu.search';
export const PUBLICATION_MENU_RULES = 'publication.page.menu.rules';
export const PUBLICATION_MENU_SUBMISSION = 'publication.page.menu.submission';
export const PUBLICATION_MENU_ARTICLE_PAYMENT = 'publication.page.menu.articlePayment';
export const PUBLICATION_MENU_ADVERTISEMENT = 'publication.page.menu.advertisement';

export const PUBLICATION_STEP_CONFIRM = 'publication.step.confirm';

const LEGACY_PUBLICATION_MENU_MAP: Record<string, string> = {
	논문검색: PUBLICATION_MENU_SEARCH,
	논문규정: PUBLICATION_MENU_RULES,
	논문투고안내: PUBLICATION_MENU_SUBMISSION,
	투고안내: PUBLICATION_MENU_SUBMISSION,
	'게재료 결제': PUBLICATION_MENU_ARTICLE_PAYMENT,
	광고게재안내: PUBLICATION_MENU_ADVERTISEMENT,
};

const LEGACY_PUBLICATION_STEP_MAP: Record<string, string> = {
	'등록 확인': PUBLICATION_STEP_CONFIRM,
};

export const normalizePublicationMenu = (value?: string | null) => {
	if (!value) {
		return PUBLICATION_MENU_SEARCH;
	}

	if (
		value === PUBLICATION_MENU_SEARCH ||
		value === PUBLICATION_MENU_RULES ||
		value === PUBLICATION_MENU_SUBMISSION ||
		value === PUBLICATION_MENU_ARTICLE_PAYMENT ||
		value === PUBLICATION_MENU_ADVERTISEMENT
	) {
		return value;
	}

	return LEGACY_PUBLICATION_MENU_MAP[value] ?? PUBLICATION_MENU_SEARCH;
};

export const normalizePublicationStep = (value?: string | null) => {
	if (!value) {
		return '';
	}

	if (value === PUBLICATION_STEP_CONFIRM) {
		return value;
	}

	return LEGACY_PUBLICATION_STEP_MAP[value] ?? '';
};
